<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        :ref="searchItemConfigModule"
        :config-module="searchItemConfigModule"
        :is-collapse-list="true"
        :grid-options="gridOptions"
        grid-config-module="210001"
        :is-append-query="true"
        :reset="true"
        lob="AI"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :record-expand-status="true"
        :input-enter-query="true"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template slot="operations">
          <el-button :disabled="!selectedRow || hqDisabledViewDetail || (!isHQ && !validSingleSelect) || hierarchyDisabledViewDetail" no="look" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <el-button
            :disabled="!(selectedRow && Number(selectedRow.jobState) === 0 && !JobUtils.isBlockJob(selectedRow)) || !validSingleSelect || !hierarchyValidSingleSelect"
            no="edit"
            type="success"
            @click="toEdit"
          >{{ $t('common.btn.edit') }}</el-button>
          <el-button v-show="$checkPermission(['button_AIBooking_addAIBooking'])" :disabled="!selectedRow || !validSingleSelect || !hierarchyValidSingleSelect" no="Copy" type="primary" @click="toCopy">{{ $t('SeaExport.Copy') }}</el-button>
          <el-upload
            no="PaymentInformationImport"
            :disabled="hqDisabledOperate"
            :action="actionUrl"
            :headers="{sessionId:context.user.sessionId}"
            :show-file-list="false"
            accept=".csv"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block;margin-left: 5px;margin-right: 5px"
          >
            <el-button :disabled="hqDisabledOperate" type="primary" @click="onPayInfoImportClick">{{ $t('SeaExport.PaymentInformationImport') }}</el-button>
          </el-upload>
          <el-button
            v-show="$checkPermission(['button_AIBooking_addAIBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
            no="new"
            :disabled="hqDisabledOperate"
            type="primary"
            style="margin-right: 5px"
            @click="toAdd()"
          >
            {{ $t('common.btn.new') }}
          </el-button>
          <el-dropdown
            v-show="$checkPermission(['button_AIBooking_addAIBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
            no="exportOrderHandle"
            :disabled="hqDisabledOperate"
            split-button
            type="primary"
            style="margin:0 5px"
            @click="exportOrderHandle()"
            @command="p=>{exportOrderCommand=p;exportOrderHandle()}"
          >
            <span v-show="exportOrderCommand !== $t('SeaExport.import')">{{ exportOrderCommand }}</span>
            <el-upload
              v-show="exportOrderCommand === $t('SeaExport.import')"
              :action="actionOrderUrl"
              :headers="headers"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeOrderUpload"
              :on-success="uploadOrderSuccess"
              :data="{branchId:$store.getters.currentOfficeId, lob:'AI'}"
              style="display: inline-block; margin-left: 5px"
            >
              <span style="color: white">{{ $t('SeaExport.import') }}</span>
            </el-upload>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.Add')">
                {{ $t('SeaExport.Add') }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.import')">
                <el-upload
                  ref="uploadOrder"
                  :action="actionOrderUrl"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :data="{branchId:$store.getters.currentOfficeId, lob:'AI'}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('SeaExport.import') }}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :command="$t('CargoMsg.Cargo_DownImportTemplate')">
                {{ $t('CargoMsg.Cargo_DownImportTemplate') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-show="$checkPermission(['button_AIBooking_addLCL'])" no="AddHbl" :disabled="hqDisabledOperate" type="primary" @click="toAdd({masterFlag: true})">{{ $t('SeaExport.AddHbl') }}</el-button>
          <el-button v-show="$checkPermission(['button_deleteAIJob'])" no="Delete" :disabled="!validMultipleSelect" type="danger" @click="toDelete">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button no="EditSopStatus" :disabled="!validMultipleSelect" type="primary" @click="editState">{{ $t('SeaExport.EditSopStatus') }}</el-button>
          <!--退回操作-->
          <el-button v-show="printReturnOperateVisible" no="ReturnAction" :disabled="!validSingleSelect || !hierarchyValidSingleSelect" type="primary" @click="backReturn(true)">{{ $t('SeaExport.ReturnAction') }}</el-button>
          <!--撤回-->
          <el-button v-show="printReturnVisible" no="PrintReturn" :disabled="!validSingleSelect || !hierarchyValidSingleSelect" type="primary" @click="backReturn(false)">{{ $t('SeaExport.PrintReturn') }}</el-button>
          <el-dropdown
            no="batchHandle"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary" :disabled="!batchSelectFlag || !validMultipleSelect">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="$checkPermission(['button_AIBooking_BatchShutOut'])" :command="23">{{ $t('SeaExport.BatchCancellation') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchPerCommit'])" :command="1">{{ $t('SeaExport.BatchPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchCommit'])" :command="2">{{ $t('SeaExport.BatchCommit') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchManagerSubmission'])" :command="3">{{ $t('SeaExport.BatchManagerSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnToOperater'])" :command="4">{{ $t('SeaExport.BatchReturnPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_Retract'])" :command="5">{{ $t('SeaExport.BatchReturnSubmit') }}</el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockReceivable'])"
                :command="12"
              >{{
                $t('SeaExport.BatchUnlockReceivableExpenses')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockPayable'])"
                :command="13"
              >{{
                $t('SeaExport.BatchUnlockPayableFees')
              }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockReceivable'])" :command="6">{{ $t('SeaExport.BatchLockingReceivableExpenses') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockPayable'])" :command="7">{{ $t('SeaExport.BatchLockingPayableFees') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_AIBooking_BatchUpdateCustomJobType'])"
                :disabled="!$checkPermission(['button_AIBooking_BatchUpdateCustomJobType'])"
                :command="8"
              >{{ $t('SeaExport.BatchUpdateCustomJobType') }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_AIBooking_BatchUpdateJobInfo'])" :command="17">{{ $t('SeaExport.BatchModifyBusiness') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_jobSopTab_BatchReplaceTemplate'])" :command="18">{{ $t('SeaExport.ReplaceSOPTemplatesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="useOrderCenterMode&&!isRegionalCommission" :command="19">{{ $t('queryJob.BatchInitiateCollaboration') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchFillGpExplain'])" :command="20">{{ $t('SeaExport.BatchFillGpExplain') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchLockJob'])" :command="21">{{ $t('CargoMsg.Cargo_BatchServiceLocking') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchUnlockJob'])" :command="22">{{ $t('CargoMsg.Cargo_UnlockServicesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnReview'])" :command="24">{{ $t('CargoMsg.Cargo_BatchReturnPreApproval') }}</el-dropdown-item>
              <!-- 指令操作按钮 -->
              <template v-for="(item, index) in instructioinBtns">
                <el-dropdown-item
                  :key="'instruction' + index"
                  :disabled="!item.allowOperate"
                  :command="'instruction,' + item.tenantInstructionUuid"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button v-show="$checkPermission(['button_print_batchPrint'])" :disabled="!batchSelectFlag || !validMultipleSelect" no="BatchPrint" type="primary" @click="onBatchPrint">{{ $t('SeaExport.BatchPrint') }}</el-button> -->
          <el-dropdown
            v-show="$checkPermission(['button_print_batchPrint'])"
            no="BatchPrint"
            :disabled="!batchSelectFlag || !validMultipleSelect"
            split-button
            type="primary"
            style="margin-right: 5px;"
            @click="onBatchPrint($t('SeaExport.BatchPrint'))"
            @command="onBatchPrint"
          >
            {{ $t('SeaExport.BatchPrint') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button no="Statistics" :disabled="!validMultipleSelect" type="primary" @click="toStatistics">{{ $t('SeaExport.Statistics') }}</el-button>
          <el-dropdown
            v-show="$checkPermission(['tab_Charge_chargeView'])"
            no="chargeHandle"
            :disabled="!validMultipleSelect"
            split-button
            type="primary"
            style="margin: 0 5px;"
            @click="chargeHandle"
            @command="p=>{chargeCommand=p;chargeHandle()}"
          >
            {{ chargeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.AddCharges')">{{ $t('SeaExport.AddCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.EditCharges')">{{ $t('SeaExport.EditCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.DeleteCharges')">{{ $t('SeaExport.DeleteCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ChargeImport')">{{ $t('SeaExport.ChargeImport') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" no="exportHandle" :disabled="!validMultipleSelect" split-button type="primary" @click="exportHandle" @command="p=>{exportCommand=p;exportHandle()}">
            {{ exportCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.ExportToExcel')">{{ $t('SeaExport.ExportToExcel') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ExportWithSOPToExcel')">{{ $t('SeaExport.ExportWithSOPToExcel') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- LTS同步-->
          <el-dropdown
            v-show="toExoSystemYGSH && $checkPermission(['button_Charge_ltsSync'])"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchLtsSyncHandle"
          >
            <el-button type="primary">
              {{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">{{ $t('SeaExport.receivable') }}</el-dropdown-item>
              <el-dropdown-item :command="2">{{ $t('SeaExport.payable') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid-wrapper
          config-module="210001"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          style="width: 100%;"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          @gridReady="params=>{gridApi=params.api}"
          @columnRowGroupChanged="() => { this.$refs[searchItemConfigModule].clickCollapseList() }"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="210001"
          :total="total"
          :page-count="pageCount"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          :selected-row-count="selectedRowCount"
          @pagination="()=>{if(total>0){toQuery()}}"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 状态修改弹窗 -->
    <state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :tracking-list="stateDialog.trackingList"
      @callback="toQuery()"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      lob="AI"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      no="statistics"
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('queryJob.SmallNumberOfVotes')">
          <el-input v-model="statisticsDialog.txtSlaves" no="txtSlaves" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('queryJob.NumberOfPrimaryVotes')">
          <el-input v-model="statisticsDialog.txtMaster" no="txtMaster" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')">
          <el-input v-model="statisticsDialog.txtCount" no="txtCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CommissionedNumberOfPackages')">
          <el-input v-model="statisticsDialog.txtQuantityContract" no="txtQuantityContract" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('queryJob.EntrustedWeight')">
          <el-input v-model="statisticsDialog.txtWeightContract" no="txtWeightContract" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CommissionedVolume')">
          <el-input v-model="statisticsDialog.txtCubageContract" no="txtCubageContract" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ChargedWeight')">
          <el-input v-model="statisticsDialog.txtChargeWeightActual" no="txtChargeWeightActual" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')">
          <el-input v-model="statisticsDialog.txtCustomerCount" no="txtCustomerCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')">
          <el-input v-model="statisticsDialog.txtDesignationAgentNum" no="txtDesignationAgentNum" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" @change="handleStatistics(true)">{{ $t('SeaExport.ContainShutOutJob') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statisticsDialog.visible=false">{{ $t('Message.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :charge-type="addChargeDetailDialog.type"
      :location="location"
      lob="AI"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 编辑费用弹窗 -->
    <edit-charge-detail-dialog
      v-if="editChargeDetailDialog.visible"
      :visible.sync="editChargeDetailDialog.visible"
      :selected-jobs="editChargeDetailDialog.selectedJobs"
      :charge-type="editChargeDetailDialog.chargeType"
      lob="AI"
    />
    <!-- 删除费用弹窗 -->
    <delete-charge-detail-dialog
      v-if="deleteChargeDetailDialog.visible"
      :visible.sync="deleteChargeDetailDialog.visible"
      :selected-jobs="deleteChargeDetailDialog.selectedJobs"
      :charge-type="deleteChargeDetailDialog.chargeType"
      lob="AI"
    />
    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :job="chargeSchemeBatchDialog.job"
      :need-check-range="chargeSchemeBatchDialog.needCheckRange"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :location="location"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />
    <!-- Lts批量同步费用 -->
    <lts-batch-sync
      ref="ltsBatchSyncCharge"
      :visible.sync="ltsWindow.visible"
      :keys="ltsWindow.keys"
    />
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />
    <!-- 批量修改业务弹窗 -->
    <batch-modify-business-dialog
      :visible.sync="batchModifyBusinessDialog.visible"
      :job-keys="batchModifyBusinessDialog.jobKeys"
      :job-list="batchModifyBusinessDialog.jobList"
      :lob="batchModifyBusinessDialog.lob"
      @callback="batchModifyBusinessCallback"
    />
    <!-- 批量修改业务SOP模板弹窗 -->
    <change-sop-template-dialog
      :visible.sync="changeSopTemplateDialog.visible"
      lob="AI"
      :job-list="changeSopTemplateDialog.jobList"
      @reload="reload"
    />
    <!-- 批量协作弹窗 -->
    <batch-cooperation-dialog :visible.sync="batchCooperationDialog.visible" :job-list="batchCooperationDialog.jobList" :order-center-branch="orderCenterBranch" />
    <!-- 下载导入模板弹窗 -->
    <download-import-template-dialog
      :visible.sync="downloadImportTemplateDialog.visible"
      :lob="downloadImportTemplateDialog.lob"
    />
    <!-- 业务申请审批流 实质是：job-apply-dialog-->
    <job-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :doc-id="workFlowApplyDialog.documentProcess.docId"
      :document-config-id="workFlowApplyDialog.documentProcess.documentConfigId"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        toQuery()
      }"
    />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="AI"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="list"
      @confirm="toQuery"
    />
    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="gpExplain.jobUuids"
    />
    <!-- 批量修改自定义业务类型弹窗 -->
    <el-dialog
      v-if="customJobTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="customJobTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateCustomJobType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('SeaExport.CustomJobType')+':'">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :method-params="{type: SystemConstants.AI.code, active: true}"
            :default-value="customJobTypeDialog.customJobType"
            @parentCallBack="p=>{customJobTypeDialog.customJobType=p.value}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="customJobTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="customJobTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 应收应付类型选择弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeTypeDialog.visible"
      :title="$t('CargoMsg.Cargo_AddCostType')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 30px 30px;">
        <el-radio-group v-model="chargeTypeDialog.type" size="small">
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
          <el-radio :label="2">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_ARAP') }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onChargeTypeDialogConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeTypeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bookingTreeGridJS from './bookingTreeGrid.js'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import addChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog'
import chargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import URL from '@/api/urlTranslator'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import LtsBatchSync from '@/components/Cargo/Job/ltsBatchSync.vue'
import EditChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/editChargeDetailDialog.vue'
import StateDialog from '@/components/Cargo/Job/StateDialog'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import DeleteChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue'
import BatchModifyBusinessDialog from '@/views/cargo/v0/SeaExport/components/booking/batchModifyBusinessDialog.vue'
import { LOG_AI_AIR_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import ChangeSopTemplateDialog from '@/components/Cargo/Job/booking/tabs/changeSopTemplateDialog'
import BatchCooperationDialog from '@/components/Cargo/Job/BatchCooperationDialog'
import { operateBranchIsOptional } from '@/utils/basicDataCache'
import DownloadImportTemplateDialog
  from '@/views/cargo/v0/SystemMaintenance/components/orderTemplateConfig/downloadImportTemplateDialog'
import JobWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { cache } from '@/utils/cacheManager'
import DateUtils from '@/utils/dateUtils'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'

export default {
  name: 'AiBookingTreeGrid',
  components: { jobReturnReviewDialog, CargoAdvanceSelect, cargoAgGridWrapper, ChangeSopTemplateDialog, BatchModifyBusinessDialog, DeleteChargeDetailDialog, EditChargeDetailDialog, searchItem, BatchCheckingWindow, cargoTemplateSelectorDialog, LtsBatchSync, addChargeDetailDialog, chargeSchemeBatchDialog, StateDialog, batchSubmitOrApproveDialog, BatchCooperationDialog, DownloadImportTemplateDialog, JobWorkFlowApplyDialog, AddGpExplainDialog },
  mixins: [BookingTreeGridMixin],
  props: {
    context: { type: Object, required: true },
    isQuery: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      notRefresh: false,
      JobUtils,
      appendQuery: false, // 追加查询
      isAdvancedQuery: false, // 是否为高级查询
      pageNum: 1,
      pageSize: 50,
      total: 0,
      pageCount: 0,
      rowData: [],
      selectedNode: null,
      selectedRows: [],
      perConfigName: '',
      gridRefreshId: 0,
      chargeCommand: this.$t('SeaExport.AddCharges'),
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      stateDialog: {
        visible: false,
        rows: [],
        trackingList: []
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      toExoSystemYGSH: false, // 阳光速航
      statisticsDialog: {
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtQuantityContract: 0,
        txtWeightContract: 0.00,
        txtCubageContract: 0.000,
        txtChargeWeightActual: 0.00,
        txtCustomerCount: 0,
        txtdesignationAgentNum: 0,
        containShutOutJob: false
      },
      addChargeDetailDialog: {
        visible: false,
        type: 0,
        selectedScheme: [],
        selectedJobs: []
      },
      chargeTypeDialog: {
        visible: false,
        selectedJobs: [],
        type: 0
      },
      role: {
        addReceivableChargeRole: this.$checkPermission(['button_Charge_payAddCharge']),
        addPayableChargeRole: this.$checkPermission(['button_Charge_costAddCharge'])
      },
      editChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      deleteChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      ltsWindow: {
        visible: false,
        keys: [],
        anyBool: false
      },
      customJobTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        customJobType: ''
      },
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        needCheckRange: true,
        isSea: false,
        lob: 'AI',
        source: 'jobList',
        chargeType: null,
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      exportOrderCommand: this.$t('SeaExport.Add'),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              // const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}</span>`
            }
          }
        },
        onRowDataChanged: event => {
          // 重置（多选）选中行
          this.selectedRows = []
          this.selectedRowCount = 0
          this.$refs[this.searchItemConfigModule].clickCollapseList()
        },
        // 单选（勾选框或者其他列，都会触发）
        onCellFocused: (event) => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        // 多选（勾选框触发）
        onRowSelected: (event) => {
          // CWUI-8 生产环境勾选业务报错为空 this.gridApi
          this.selectedRows = event.api.getSelectedRows()
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          if (this.hierarchyViewList && !this.hierarchyViewDetail) {
            if (!this.matchOwnerBranch(event.data)) {
              return
            }
          }
          if (this.hqViewAllList) {
            const curOfficeId = this.$store.getters.currentOfficeId
            const data = event.data
            if (curOfficeId === 1) {
              if (!this.hqViewAllDetail) {
                return
              }
            } else {
              let needCheck = true
              if (!this.isZy && this.hierarchyViewDetail) {
                if (this.childOfficeIds.includes(data.opOffice) || this.childOfficeIds.includes(data.salesOffice)) {
                  needCheck = false
                }
              }
              if (needCheck) {
                if (data.opOffice !== curOfficeId && data.salesOffice !== curOfficeId && !this.mactchCooperateBranch(data.cooperatebranch, this.$store.getters.currentOffice)) {
                  return
                }
              }
            }
          }
          this.toLook(event.data)
        },
        getRowStyle: (params) => {
          if (!params.data) {
            return {}
          }
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onSelectionChanged: (event) => {
          const allRow = event.api.getSelectedRows()
          const selectedRows = []
          for (const row of allRow) {
            if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
              selectedRows.push(row)
            }
          }
          this.selectedRowCount = selectedRows.length
        }
      },
      selectedRowCount: 0,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Mbl2'),
          field: 'mbl',
          cellRenderer: params => ColumnUtils.mawbNoLabelFun(params.value, this.airMblDisplayStyle),
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          field: 'poNo',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          field: 'customerTypeId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          field: 'contractStatus',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          field: 'cargoSalesId',
          hide: true,
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCargoSalesId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          hide: true,
          width: 180,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.OverseaCustomerService'),
          field: 'overseaOp',
          hide: true,
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOverseaOp), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CustomerReferenceNumber'),
          field: 'customerRefNo',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Remarks'), field: 'remarks', width: 180, colId: 'remarks', enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          }
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: 'customJobType',
          hide: true,
          width: 150,
          enableRowGroup: true,
          valueGetter: params => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', SystemConstants.AI.code, false)
          }
        }, {
          headerName: this.$t('SeaExport.PortOfLoadingAgent'),
          field: 'loadingAgentId',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierId',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Flight'),
          field: 'voyageFlight',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.LoadingPort'),
          field: 'loadingPortCode',
          width: 180,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
          }
        }, {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'dischargingPortCode',
          width: 130,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
          }
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityContract',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightContract',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageContract',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('queryJob.OperateType'),
          field: 'operateType',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('SeaExport.Invalid'),
          field: 'shutOut',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        }, {
          headerName: this.$t('Billing.InvalidDate'),
          field: 'shutOutDate',
          colId: 'shutOutDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfArrival2'),
          field: 'eta',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfDelivery'),
          field: 'deliverDate',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Storage'),
          field: 'warehousing',
          width: 120,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.DeliveryToDoor'),
          field: 'landTransportation',
          width: 120,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        }, {
          headerName: ' ' + this.$t('SeaExport.CustomsDeclaration') + ' ',
          field: 'customs',
          width: 120,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          field: 'customsBroker',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessStatus'),
          field: 'jobState',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filter: false,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          }
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOpId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateSales), 'auto_sales')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Accrued'),
          field: 'provisioned',
          hide: true,
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCsrId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateDcId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.SOPStatus'),
          field: 'sopState',
          width: 150,
          enableRowGroup: true,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ManageAuditStatus'),
          field: 'manageAuditStatus',
          width: 135,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.manageAuditStatusLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: 'etd',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.AirlinePerson2'),
          field: 'planner',
          width: 150,
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperatePlanner), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          field: 'customsDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
          field: 'receivableChargeLockedStatus',
          colId: 'receivableChargeLockedStatus',
          hide: true,
          width: 150,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
          field: 'payableChargeLockedStatus',
          colId: 'payableChargeLockedStatus',
          hide: true,
          width: 150,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          field: 'shipperLine1',
          colId: 'shipperLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        { headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
          field: 'atd',
          width: 180,
          colId: 'atd',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ActualDateOfArrival2'),
          field: 'ata',
          width: 180,
          colId: 'ata',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId1), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId2), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: 'preCommitUser',
          colId: 'preCommitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: 'preCommitDate',
          colId: 'preCommitDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: 'commitUser',
          colId: 'commitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: 'submissionDate',
          colId: 'submissionDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditUser'),
          field: 'fcAuditUser',
          colId: 'fcAuditUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditDate'),
          field: 'fcAuditDate',
          colId: 'fcAuditDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: 'lockJobUser',
          colId: 'lockJobUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: 'lockJobDate',
          colId: 'lockJobDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateSalesOffice), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateOpCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDept',
          colId: 'salesDept',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateSalesDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateOpDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.DelegatedAssociatedBusinessStatus'),
          field: 'trustJobState',
          colId: 'trustJobState',
          hide: true,
          enableRowGroup: true,
          valueFormatter: params => {
            let value = params.value
            if (typeof value === 'string') {
              value = Number(value)
              if (isNaN(value)) {
                return ''
              }
            }
            return typeof value === 'number' ? ColumnUtils.getJobStateCN(value) : ''
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.TransactionRelatedBusinessStatus'),
          field: 'relatedJobState',
          colId: 'relatedJobState',
          hide: true,
          enableRowGroup: true,
          valueFormatter: params => {
            let value = params.value
            if (typeof value === 'string') {
              value = Number(value)
              if (isNaN(value)) {
                return ''
              }
            }
            return typeof value === 'number' ? ColumnUtils.getJobStateCN(value) : ''
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactPhone'),
          field: 'telephone',
          colId: 'telephone',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactMobile'),
          field: 'mobile',
          colId: 'mobile',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('queryJob.receivablesWriteOfStatus'),
          colId: 'verifyStateReceivable',
          field: 'verifyStateReceivable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('queryJob.payablesWriteOfStatus'),
          colId: 'verifyStatePayable',
          field: 'verifyStatePayable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: 'receivableChargeInput',
          colId: 'receivableChargeInput',
          width: 150,
          hide: true,
          filter: false,
          enableRowGroup: true,
          filterParams: {},
          valueFormatter: params => {
            return ColumnUtils.chargeInputLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: 'costChargeInput',
          colId: 'costChargeInput',
          width: 150,
          hide: true,
          filter: false,
          enableRowGroup: true,
          filterParams: {},
          valueFormatter: params => {
            return ColumnUtils.chargeInputLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
          colId: 'receivableInvoiceState',
          field: 'receivableInvoiceState',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueFormatter: params => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.MasterBusinessNo'),
          colId: 'masterJobNo',
          field: 'masterJobNo',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          enableRowGroup: true,
          valueFormatter: params => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName') : ''
          },
          width: 200,
          hide: true
        }, {
          headerName: this.$t('SeaExport.TradeMethod'),
          field: 'tradeTerm',
          colId: 'tradeTerm',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', params.value, 'name')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'projectName',
          colId: 'projectName',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectBatch'),
          field: 'projectBatch',
          colId: 'projectBatch',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('common.createBy'),
          field: 'createdBy',
          hide: true,
          width: 130,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
          field: 'trackingTemplateUuid',
          width: 180,
          colId: 'trackingTemplateUuid',
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        },
        { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: 'jobProfitShare', width: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('queryJob.EstimatedReviewer'),
          field: 'preverifier',
          colId: 'preVerifier',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('queryJob.DateOfPreReview'),
          field: 'preverifyDate',
          colId: 'preVerifyDate',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.AirportHandlingAgent'),
          field: 'groundAgentId',
          width: 200,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: 'specialApprovalDate', width: 150, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: 'csrDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.data.cooperateCsrDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: 'dcDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.data.cooperateDcDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          colId: 'plannerDepartment',
          field: 'plannerDepartment',
          width: 140,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Airline'),
          field: 'regionName',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateCsrCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateDcCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'jobSoNo',
          hide: true,
          valueFormatter: (params) => {
            return params.value ? params.value.replace(/\n/g, ',') : ''
          },
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
          colId: 'verifyStateReceivableDomestic',
          field: 'verifyStateReceivableDomestic',
          width: 140,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
          colId: 'verifyStateReceivableOversea',
          field: 'verifyStateReceivableOversea',
          width: 140,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TransportSource'),
          field: 'transportSource',
          colId: 'transportSource',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransportSource, 'code', params.value, 'name')
          },
          enableRowGroup: true,
          width: 150
        },
        { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: 'businessLock', width: 100, colId: 'businessLock',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLockedStatusLabelFunc(stringToBool(params.value))
          },
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'settlementType', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'dateLimited', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: 'creditInfoDateExceeded', width: 100, hide: true, enableRowGroup: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: 'creditInfoAmountExceeded', width: 100, hide: true, enableRowGroup: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        {
          headerName: this.$t('SeaExport.AdvancePayment'),
          field: 'advancePayment',
          colId: 'advancePayment',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CustomsDutyAmount'),
          field: 'customsDutyAmount',
          colId: 'customsDutyAmount',
          enableRowGroup: true,
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('SeaExport.VatAmount'),
          field: 'vatAmount',
          colId: 'vatAmount',
          enableRowGroup: true,
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('SeaExport.PaymentTime'),
          field: 'paymentTime',
          colId: 'paymentTime',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationNo'),
          field: 'customsDeclarationNo',
          colId: 'customsDeclarationNo',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DateOfArrivalTheWarehouse'),
          field: 'arriveStorageDate',
          colId: 'arriveStorageDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
          colId: 'payableInvoiceState',
          field: 'payableInvoiceState',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.receivableInvoiceStateLabelFunction(params.data.payableInvoiceState),
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
          colId: 'receivableChargeLockedDate',
          field: 'receivableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
          colId: 'payableChargeLockedDate',
          field: 'payableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          colId: 'payableChargeLockedPerson',
          field: 'payableChargeLockedPerson',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
          colId: 'interestAmountCurrency',
          field: 'interestAmountCurrency',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CheckRuleResult'),
          colId: 'checkRuleResult',
          field: 'checkRuleResult',
          width: 100,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.CheckRuleResultLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: 'relatedJob',
          width: 150,
          hide: true,
          enableRowGroup: true
        }
      ],
      customSearchItems: [],
      filterJson: {},
      documentManage: new DocumentManage(),
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      paramsBpm: [],
      opOffice: null,
      batchModifyBusinessDialog: {
        visible: false,
        jobList: [],
        jobKeys: [],
        lob: ''
      },
      location: LOG_AI_AIR_BOOKING.code,
      changeSopTemplateDialog: {
        visible: false,
        jobList: []
      },
      batchCooperationDialog: {
        visible: false,
        jobList: []
      },
      downloadImportTemplateDialog: {
        visible: false,
        lob: 'AI'
      },
      workFlowApplyDialog: {
        visible: false
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      arSettlementUnitOptional: false,
      isBpmEnabled: false,
      defaultSearchItems: [],
      gpExplain: {
        type: 'list',
        visible: false,
        jobUuids: []
      },
      isZY: false,
      airMblDisplayStyle: false, // 空运主单号格式
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      cancellationJobKeys: '',
      instructioinBtns: [] // 指令按钮列表
    }
  },
  computed: {
    searchItemConfigModule() {
      return '400'
    },
    SystemConstants() {
      return SystemConstants
    },
    selectedRow() {
      if (this.rowData.length === 1) {
        return this.rowData[0]
      }
      return this.selectedNode ? this.selectedNode.data : null
    },
    batchSelectFlag() {
      return this.selectedRows.length > 0
    },
    actionUrl() {
      return URL.booking.airImport.importCSVFile + '?branchId=' + this.$store.getters.currentOfficeId
    },
    printReturnVisible() {
      return this.$checkPermission(['button_JobBooking_Retract']) && this.selectedRow && this.selectedRow.jobState === SystemConstants.COMMITED
    },
    printReturnOperateVisible() {
      return this.$checkPermission(['button_JobBooking_ReturnToOperater']) && this.selectedRow && this.selectedRow.jobState === SystemConstants.PRE_COMMIT
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    actionOrderUrl() {
      return URL.sys.importOrderTemplate
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.context.config ? Number(this.context.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.context.config ? Number(this.context.config.get('orderCenterBranch')) === 1 : false
    },
    isHQ() {
      return this.$store.getters.currentOfficeId === 1
    },
    conditonDisplayAllBranchData() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledViewDetail() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList && !this.hqViewAllDetail
    },
    validSingleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (!this.isZy && this.hierarchyViewDetail && this.selectedRow) {
          if (this.childOfficeIds.includes(this.selectedRow.opOffice) || this.childOfficeIds.includes(this.selectedRow.salesOffice)) {
            return true
          }
        }
        if (this.selectedRow && this.selectedRow.opOffice !== this.$store.getters.currentOfficeId && this.selectedRow.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.selectedRow.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.selectedRows) {
          if (!this.isZy && this.hierarchyViewDetail && row) {
            if (this.childOfficeIds.includes(row.opOffice) || this.childOfficeIds.includes(row.salesOffice)) {
              return true
            }
          }
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    },
    finalColumnDefs() {
      let result = []
      for (const columnDef of this.columnDefs) {
        result.push({ ...columnDef })
      }
      if (this.$store.state.uiCustom.enable) {
        result = UICustomUtil.handleColumnDefs(UICustomConstants.AI_BOOKING_MODULE, this.$store.getters.currentOfficeId, result)
      }
      return result
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        if (this.hierarchyViewList) {
          this.customSearchItems = await this.getCustomSearchItems()
        }
        this.loadInstructionButtons()
      }
    }
  },
  async created() {
    await this.context.prepareData().then(async() => {
      this.allowPartialCheckPass = Number(this.context.config.get('allowPartialCheckPass')) === 1
      this.checkApChargeVerify = Number(this.context.config.get('PreCommitJobCheckApChargeStateVerify')) === 1
      this.useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      this.chargeSchemeBatchDialog.chargeSchemeIsApproved = Number(this.context.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.toExoSystemYGSH = String(this.context.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
        documentConfigId: Job_CHARGE.code,
        officeId: this.$store.getters.currentOfficeId
      })
      this.arSettlementUnitOptional = parseInt(this.context.config.get('ArSettlementUnitOptional')) === 1
      this.isZY = String(this.context.config.get('ToExoSystem')) === 'zy'
      this.dataListDragGroup = Number(this.context.config.get('DataListDragGroup')) === 1
      this.airMblDisplayStyle = Number(this.context.config.get('AirMblDisplayStyle')) === 1
    })
    this.TYPE_NAMES = TYPE_NAMES
    await this.initColumnDefs()
    this.loadInstructionButtons()
    /*
    this.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
      suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
      treeData: true,
      groupDefaultExpanded: 2,
      getDataPath: data => {
        return data.path.split(',')
      },
      autoGroupColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          checkbox: params => {
            const currentJob = params.data
            if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
              return false
            }
            return true
          },
          innerRenderer: params => {
            const methodPath = this.documentManage.getPath('showBusinessInfo')
            return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
          }
        }
      },
      onRowDataChanged: event => {
        // 重置（多选）选中行
        this.selectedRows = []
      },
      // 单选（勾选框或者其他列，都会触发）
      onCellFocused: (event) => {
        const nodes = event.api.rowModel.rowsToDisplay
        this.selectedNode = nodes[event.rowIndex] || null
      },
      // 多选（勾选框触发）
      onRowSelected: (event) => {
        this.selectedRows = this.gridApi.getSelectedRows()
      },
      onCellDoubleClicked: event => {
        this.toLook(event.data)
      },
      getRowStyle: (params) => {
        const row = params.data
        const { colorSettings } = this
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of colorSettings) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
        }
        return {}
      },
      onSortChanged: event => {
        if (this.selectedNode) {
          event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
        }
      },
      defaultColDef: {
        resizable: true
      },
      context: {
        componentParent: this
      }
    }
    this.columnDefs = [
      {
        headerName: this.$t('SeaExport.ConsignationCompany'),
        field: 'customerId',
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        },
        width: 200
      }, {
        headerName: this.$t('SeaExport.Mbl2'),
        field: 'mbl',
        width: 150
      }, {
        headerName: this.$t('SeaExport.Hbl2'),
        field: 'hbl',
        width: 150
      }, {
        headerName: this.$t('SeaExport.ItemNo'),
        field: 'poNo',
        width: 150
      }, {
        headerName: this.$t('SeaExport.CustomerLevel'),
        field: 'customerTypeId',
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContractStatus'),
        field: 'contractStatus',
        width: 150
      }, {
        headerName: this.$t('SeaExport.SalesOfGoods'),
        field: 'cargoSalesId',
        hide: true,
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.TradeTerms2'),
        field: 'incoTerm',
        hide: true,
        width: 180
      }, {
        headerName: this.$t('SeaExport.OverseaCustomerService'),
        field: 'overseaOp',
        hide: true,
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.CustomerReferenceNumber'),
        field: 'customerRefNo',
        width: 150
      }, {
        headerName: this.$t('SeaExport.SolicitationType'),
        field: 'cargoSource',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.cargoSourceLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.NominatedAgent'),
        field: 'designationAgent',
        width: 200,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
        }
      }, {
        headerName: this.$t('SeaExport.ChargedWeight'),
        field: 'chargeWeight',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.CustomJobType'),
        field: 'customJobType',
        hide: true,
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
        }
      }, {
        headerName: this.$t('SeaExport.PortOfLoadingAgent'),
        field: 'loadingAgentId',
        width: 200,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'englishName')
        }
      }, {
        headerName: this.$t('SeaExport.BillExchangeAgent'),
        field: 'bookingAgent',
        width: 200,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.AirlineCompany'),
        field: 'carrierId',
        width: 200,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.Flight'),
        field: 'voyageFlight',
        width: 150
      }, {
        headerName: this.$t('SeaExport.LoadingPort'),
        field: 'loadingPortCode',
        width: 180
      }, {
        headerName: this.$t('SeaExport.PortOfDestination'),
        field: 'dischargingPortCode',
        width: 130
      }, {
        headerName: this.$t('SeaExport.Quantity'),
        field: 'quantityContract',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.numberColumnLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.Weight'),
        field: 'weightContract',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.Cubage'),
        field: 'cubageContract',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('queryJob.OperateType'),
        field: 'operateType',
        width: 180,
        cellRenderer: params => {
          return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
        },
        filter: false,
        filterParams: {}
      }, {
        headerName: this.$t('SeaExport.Invalid'),
        field: 'shutOut',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DateOfArrival2'),
        field: 'eta',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DateOfDelivery'),
        field: 'deliverDate',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.Storage'),
        field: 'warehousing',
        width: 120,
        cellRenderer: params => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DeliveryToDoor'),
        field: 'landTransportation',
        width: 120,
        cellRenderer: params => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: ' ' + this.$t('SeaExport.CustomsDeclaration') + ' ',
        field: 'customs',
        width: 120,
        cellRenderer: params => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.CustomsBroker'),
        field: 'customsBroker',
        width: 200,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.HaulageCompany'),
        field: 'carryingCmp',
        width: 200,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
        field: 'cargoChineseName',
        width: 150
      }, {
        headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
        field: 'cargoEnglishName',
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_BusinessStatus'),
        field: 'jobState',
        width: 150,
        cellRenderer: params => {
          if (JobUtils.isBlockJob(params.data)) {
            return this.$t('Message.Locked')
          } else {
            return ColumnUtils.getJobStateCN(params.value)
          }
        },
        filter: false,
        filterParams: {}
      }, {
        headerName: this.$t('SeaExport.Operation'),
        field: 'op',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.Sales'),
        field: 'sales',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.Accrued'),
        field: 'provisioned',
        hide: true,
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.CustomerService'),
        field: 'csr',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.Documents'),
        field: 'dc',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.SOPStatus'),
        field: 'sopState',
        width: 150,
        cellRendererFramework: 'CargoGridShowBigContent'
      }, {
        headerName: this.$t('SeaExport.DateOfCreation'),
        field: 'dateCreated',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField1'),
        field: 'userDefinedField1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField2'),
        field: 'userDefinedField2',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField3'),
        field: 'userDefinedField3',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField4'),
        field: 'userDefinedField4',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ManageAuditStatus'),
        field: 'manageAuditStatus',
        width: 135,
        cellRenderer: params => {
          return ColumnUtils.manageAuditStatusLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.DateOfDeparture2'),
        field: 'etd',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.AirlinePerson2'),
        field: 'planner',
        width: 150,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.OperationDate'),
        field: 'customsDate',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
        field: 'receivableChargeLockedStatus',
        colId: 'receivableChargeLockedStatus',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.chargeLockedStatusLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
        field: 'payableChargeLockedStatus',
        colId: 'payableChargeLockedStatus',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.chargeLockedStatusLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.Consignee'),
        colId: 'consigneeLine1',
        field: 'consigneeLine1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Shipper'),
        field: 'shipperLine1',
        colId: 'shipperLine1',
        hide: true,
        width: 150
      },
      { headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
        field: 'atd',
        width: 180,
        colId: 'atd',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('SeaExport.ActualDateOfArrival2'),
        field: 'ata',
        width: 180,
        colId: 'ata',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
        field: 'userDefinedRoleId1',
        colId: 'userDefinedRoleId1',
        width: 150,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
        field: 'userDefinedRoleId2',
        colId: 'userDefinedRoleId2',
        width: 150,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.PreCommitUser'),
        field: 'preCommitUser',
        colId: 'preCommitUser',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.PreCommitDate'),
        field: 'preCommitDate',
        colId: 'preCommitDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.CommitUser'),
        field: 'commitUser',
        colId: 'commitUser',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.SubmissionDate'),
        field: 'submissionDate',
        colId: 'submissionDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.FcAuditUser'),
        field: 'fcAuditUser',
        colId: 'fcAuditUser',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.FcAuditDate'),
        field: 'fcAuditDate',
        colId: 'fcAuditDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.LockJobUser'),
        field: 'lockJobUser',
        colId: 'lockJobUser',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.LockJobDate'),
        field: 'lockJobDate',
        colId: 'lockJobDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
        field: 'salesOffice',
        colId: 'salesOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
        field: 'opOffice',
        colId: 'opOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
        field: 'salesDept',
        colId: 'salesDept',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
        field: 'opDepartment',
        colId: 'opDepartment',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.CategoryOfGoods'),
        field: 'cargoCode',
        colId: 'cargoCode',
        cellRenderer: (params) => {
          return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
        },
        hide: true,
        width: 200
      }, {
        headerName: this.$t('SeaExport.DelegatedAssociatedBusinessStatus'),
        field: 'trustJobState',
        colId: 'trustJobState',
        hide: true,
        valueFormatter: params => {
          return typeof params.value === 'number' ? ColumnUtils.getJobStateCN(params.value) : ''
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.TransactionRelatedBusinessStatus'),
        field: 'relatedJobState',
        colId: 'relatedJobState',
        hide: true,
        valueFormatter: params => {
          return typeof params.value === 'number' ? ColumnUtils.getJobStateCN(params.value) : ''
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.CustomerContactPerson'),
        field: 'customerContact',
        colId: 'customerContact',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContactPhone'),
        field: 'telephone',
        colId: 'telephone',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContactMobile'),
        field: 'mobile',
        colId: 'mobile',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('queryJob.receivablesWriteOfStatus'),
        colId: 'verifyStateReceivable',
        field: 'verifyStateReceivable',
        width: 150,
        hide: true
      }, {
        headerName: this.$t('queryJob.payablesWriteOfStatus'),
        colId: 'verifyStatePayable',
        field: 'verifyStatePayable',
        width: 150,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
        field: 'receivableChargeInput',
        colId: 'receivableChargeInput',
        width: 150,
        hide: true,
        filter: false,
        filterParams: {},
        valueFormatter: params => {
          return ColumnUtils.chargeInputLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
        field: 'costChargeInput',
        colId: 'costChargeInput',
        width: 150,
        hide: true,
        filter: false,
        filterParams: {},
        valueFormatter: params => {
          return ColumnUtils.chargeInputLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
        colId: 'receivableInvoiceState',
        field: 'receivableInvoiceState',
        width: 150,
        hide: true,
        valueFormatter: params => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.MasterBusinessNo'),
        colId: 'masterJobNo',
        field: 'masterJobNo',
        width: 150,
        hide: true
      }, {
        headerName: this.$t('SeaExport.Warehouse'),
        field: 'warehouseCmp',
        colId: 'warehouseCmp',
        valueFormatter: params => {
          return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
        },
        width: 200,
        hide: true
      }, {
        headerName: this.$t('SeaExport.TradeMethod'),
        field: 'tradeTerm',
        colId: 'tradeTerm',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', params.value, 'name')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ProjectName'),
        field: 'projectName',
        colId: 'projectName',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ProjectBatch'),
        field: 'projectBatch',
        colId: 'projectBatch',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('common.createBy'),
        field: 'createdBy',
        hide: true,
        width: 130,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
        field: 'trackingTemplateUuid',
        width: 180,
        colId: 'trackingTemplateUuid',
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
        }
      }
    ]
    */
    this.gridApi = null
    this.btnInfo = {
      operateNameCode: '',
      showMessage: false
    }
    // this.documentManage = new DocumentManage()
    this.customSearchItems = await this.getCustomSearchItems()
    if (this.isQuery) return
    this.queryLastModifyBookingByDay()
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showBusinessInfo', function() {
      self.showBusinessInfo()
    })
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(self, self.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
  },
  mounted() {
    if (this.$route.params.job) {
      setTimeout(job => {
        this.$emit('add', job)
      }, 100, this.$route.params.job)
      delete this.$route.params.job
    }
  },
  activated() {
    if (this.$route.params.job) {
      this.$emit('add', this.$route.params.job)
      delete this.$route.params.job
    }
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: bookingTreeGridJS.methods
}
</script>

<style scoped lang="scss">
#app .grid-view .main-content {
  .grid-wrapper ::v-deep {
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
